import { SeatSplitting } from "../types";

export function calculateAvailableSeats(seatSplitting: SeatSplitting | undefined) {
  if (!seatSplitting) return { silver: 0, gold: 0, diamond: 0, total: 0 };

  const silverAvailable = Math.max(0, seatSplitting.silver_total - seatSplitting.silver_booked);
  const goldAvailable = Math.max(0, seatSplitting.gold_total - seatSplitting.gold_booked);
  const diamondAvailable = Math.max(0, seatSplitting.diamond_total - seatSplitting.diamond_booked);
  
  return {
    silver: silverAvailable,
    gold: goldAvailable,
    diamond: diamondAvailable,
    total: silverAvailable + goldAvailable + diamondAvailable
  };
}